import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=f1f6cff2&scoped=true&"
import script from "./IconTooltip.vue?vue&type=script&lang=js&"
export * from "./IconTooltip.vue?vue&type=script&lang=js&"
import style0 from "./IconTooltip.vue?vue&type=style&index=0&id=f1f6cff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f6cff2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
